import { AuthToken } from './auth.model';
import { AzureLoginResult } from './azure-oauth.model';

export interface LoginResult {
  authResult: AzureLoginResult;
  authToken: AuthToken | undefined;
}

export const loginAborted: string = 'USER_CANCELLED';
export const resetPasswordRequested: string = 'RESET_PASSWORD';

export const loginRedirect: string = 'LOGIN_REDIRECT';
